import * as React from 'react';

export default function OffcanvasContent(props) {
  return (
    <div className='nv-chart__offcanvas'>
      {props.children}
    </div>
  );
}
